module.exports = "/public/images/aa7bb2a0159ba1fac94ec26eaa59ee49.svg";